// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"7800df702e7aae09","5283":"1d41cf5ade133408","5405":"1d41cf5ade133408"}[chunkId] + ".css";
};